import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=c8ca4092&scoped=true&"
import script from "./breadCrumb.vue?vue&type=script&lang=js&"
export * from "./breadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./breadCrumb.vue?vue&type=style&index=0&id=c8ca4092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ca4092",
  null
  
)

export default component.exports